import React, { Component } from "react";
import { Col, Row } from "reactstrap";

class ProfileMenuHeader extends Component {
  render() {
    return (
      <>
      <br/>
      <br/>
        <Row>
          <Col>
            <a href={this.props.back || window.document.referrer} className="back-btn">
              {"< "}
            </a>
            <h4>{this.props.heading}</h4>
            <hr />
          </Col>
        </Row>
      </>
    );
  }
}

export default ProfileMenuHeader;
